import { InviteAccountMemberRequestBody } from "@syla/shared/types/requests/InviteAccountMemberRequest";
import { useMutation } from "react-query";
import { inviteAccountMember } from "../api/account/inviteAccountMember";

import { queryClient } from "./transactionsStore";
import { ACCOUNT_META_QUERY_KEY } from "./useQueryGetAccounts";

export const useMutationInviteAccountMember = (accountId: string) =>
  useMutation(
    (props: InviteAccountMemberRequestBody) =>
      inviteAccountMember(accountId, props),
    {
      mutationKey: [...ACCOUNT_META_QUERY_KEY, accountId],
      onSettled: () => {
        queryClient.invalidateQueries([...ACCOUNT_META_QUERY_KEY]);
      },
    },
  );
